exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#alerts-configuration-page-container{width:100%;padding:20px;background-color:#fff}#alerts-configuration-page-container #alerts-configuration-title{display:none;width:100%;text-align:left;font-size:26px;padding-left:10px}#alerts-configuration-page-container .alerts-configuration-list{padding:10px;width:100%}#alerts-configuration-page-container .alerts-configuration-list .ant-table-row{text-align:center}#alerts-configuration-page-container .alerts-configuration-list .alerts-configuration-list-element{width:100%;font-size:26px;border-bottom:1px solid #000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./styles/alerts/configuration.scss
// module id = 2194
// module chunks = 43